import { Box, Stack } from "@mui/material";
import { TempChilled20Px, TempFrozen20Px } from "@qubit/autoparts";

import { useAppSelector } from "~/app/store";
import { tempZoneBasedColor } from "~/lib/tempZone";

import { selectBatches } from "./batchCards.slice";

type TempZonesChipProps = {
  batchId: Guid;
};
export const TemperatureZoneIndicator = ({ batchId }: TempZonesChipProps) => {
  const batch = useAppSelector(selectBatches).find(
    (b) => b.batchId === batchId
  );
  const temperatureZones = batch?.temperatureZones || [];
  return (
    <Stack width={36}>
      {temperatureZones.map((tempZone, i) => (
        <Box
          key={`${batchId}-${i}`}
          justifyContent="flex-end"
          alignItems="center"
          flexGrow={1}
          py={1}
          width={36}
          bgcolor={tempZoneBasedColor(tempZone)}
          aria-label={`${batchId}-${i}-temp-zone-color`}
        >
          {tempZone.toLowerCase() === "chilled" && (
            <TempChilled20Px
              aria-label={`${batchId}-${i}-chilled-temp-zone-icon`}
            />
          )}
          {tempZone.toLowerCase() === "frozen" && (
            <TempFrozen20Px
              aria-label={`${batchId}-${i}-frozen-temp-zone-icon`}
            />
          )}
        </Box>
      ))}
    </Stack>
  );
};
